import { ListPageLoadingFallback } from "@/components/templates/list-page-loading-fallback"

/**
 * Dashboard route fallback — package hub skeleton (DS `Skeleton`).
 */
export function DashboardLoadingFallback() {
  return <ListPageLoadingFallback showMetrics tabCount={3} rowCount={5} />
}
